import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { EPP } from "../../../../api";
import { useAuth } from "../../../../hooks";

const eppController = new EPP();

const CATEGORY_OPTIONS = [
  { key: "",           value: "",           text: "— Sin categoría —" },
  { key: "cabeza",     value: "cabeza",     text: "Protección de cabeza" },
  { key: "ojos_cara",  value: "ojos_cara",  text: "Protección de ojos y cara" },
  { key: "oidos",      value: "oidos",      text: "Protección auditiva" },
  { key: "respiratoria", value: "respiratoria", text: "Protección respiratoria" },
  { key: "manos",      value: "manos",      text: "Protección de manos" },
  { key: "pies",       value: "pies",       text: "Protección de pies" },
  { key: "cuerpo",     value: "cuerpo",     text: "Protección del cuerpo" },
  { key: "anticaidas", value: "anticaidas", text: "Anti-caídas / Altura" },
  { key: "otro",       value: "otro",       text: "Otro" },
];

export function EPPForm({ epp, close, onReload }) {
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: {
      code:        epp?.code        || "",
      name:        epp?.name        || "",
      category:    epp?.category    || "",
      standard:    epp?.standard    || "",
      description: epp?.description || "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required("El código es requerido"),
      name: Yup.string().required("El nombre es requerido"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (epp) {
          await eppController.updateEPP(accessToken, epp._id, values);
          toast.success("EPP actualizado");
        } else {
          await eppController.createEPP(accessToken, values);
          toast.success("EPP creado");
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || "Error al guardar");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />

      <Form.Input
        label="Código"
        name="code"
        value={formik.values.code}
        onChange={e => formik.setFieldValue("code", e.target.value.toUpperCase())}
        error={formik.errors.code}
        placeholder="Ej: RESP-FFP2"
      />
      <Form.Input
        label="Nombre"
        name="name"
        value={formik.values.name}
        onChange={e => {
          const v = e.target.value;
          formik.setFieldValue("name", v.charAt(0).toUpperCase() + v.slice(1));
        }}
        error={formik.errors.name}
        placeholder="Ej: Mascarilla FFP2 / N95"
      />
      <Form.Select
        label="Categoría"
        options={CATEGORY_OPTIONS}
        value={formik.values.category}
        onChange={(_, { value }) => formik.setFieldValue("category", value)}
        placeholder="Seleccioná una categoría"
      />
      <Form.Input
        label="Normativa / Estándar"
        name="standard"
        value={formik.values.standard}
        onChange={e => formik.setFieldValue("standard", e.target.value)}
        placeholder="Ej: IRAM 3572, EN 149, NOM-116"
      />
      <Form.TextArea
        label="Descripción"
        name="description"
        value={formik.values.description}
        onChange={e => formik.setFieldValue("description", e.target.value)}
        placeholder="Descripción adicional del EPP..."
        rows={3}
      />

      <div style={{ display: "flex", justifyContent: "center", gap: "0.5rem", marginTop: "1.2rem" }}>
        <Button primary type="submit" loading={formik.isSubmitting} disabled={formik.isSubmitting} style={{ minWidth: "8rem" }}>
          {epp ? "Actualizar" : "Guardar"}
        </Button>
        <Button type="button" onClick={close} style={{ minWidth: "8rem" }}>Cancelar</Button>
      </div>
    </Form>
  );
}
